import { GetApiV1ThreeLetterCodePartnerAdminsTopBanners200 } from '@fukuri-admins/apis/client/gen/model';
import { getTopBannerCreateLink } from '~/utils/getLinks';
import { TopBannerListPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof TopBannerListPresentation>;

/**
 * TopBannerListPresentation に渡す props へ変換する際の引数オブジェクト
 */
type Args = {
  /** トップバナー一覧 API のレスポンスデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsTopBanners200;
};

type IConvertToPresentationProps = (args: Args) => {
  topBanners: PresentationProps['topBanners'];
  createLink: PresentationProps['createLink'];
};

/**
 * target_user_type の値を表示テキストへ変換する
 */
const resolveTargetUserTypeLabel = (targetUserType: string): string => {
  if (targetUserType === 'employees_only') return '従業員のみ';
  return 'すべて（従業員＋家族）';
};

export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => ({
  topBanners: data.top_banners.map(banner => ({
    id: banner.id,
    title: banner.title,
    transitionUrl: banner.transition_url,
    isActive: banner.status === 'active',
    sortOrder: banner.sort_order,
    imageUrl: banner.image.url ?? '',
    groupName: banner.group?.name ?? '-',
    targetUserTypeLabel: resolveTargetUserTypeLabel(banner.target_user_type),
  })),
  createLink: getTopBannerCreateLink(),
});
